"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalizationsMock = exports.useLocalizationMock = void 0;
function useLocalizationMock(_id, defaultValue, variablesOrMode) {
    var renderResult = function (variables) {
        if (variables === undefined) {
            return defaultValue;
        }
        return "".concat(defaultValue, " (").concat(JSON.stringify(variables), ")");
    };
    if (variablesOrMode === 'dynamic') {
        return function (variables) { return renderResult(variables); };
    }
    return renderResult(variablesOrMode);
}
exports.useLocalizationMock = useLocalizationMock;
function useLocalizationsMock(idsAndDefaultValues, variablesOrMode) {
    var renderResult = function (id, variables) {
        if (variables === undefined) {
            return idsAndDefaultValues[id];
        }
        return "".concat(idsAndDefaultValues[id], " (").concat(JSON.stringify(variables), ")");
    };
    var results = Object.keys(idsAndDefaultValues).reduce(function (memo, key) {
        var _a;
        return (__assign(__assign({}, memo), (_a = {}, _a[key] = variablesOrMode === 'dynamic'
            ? function (variables) { return renderResult(key, variables); }
            : renderResult(key, variablesOrMode), _a)));
    }, {});
    return results;
}
exports.useLocalizationsMock = useLocalizationsMock;
